import { css } from 'styled-components'
import config from '@config'
import { captureException } from '@utils/sentry'

interface PianoTokenResponse {
  userRefToken?: string
}

interface PianoCustomVariables {
  [key: string]: string
}

const {
  piano: { tokenUrl, experienceCookieName, modalZIndex },
} = config

const setCustomVariables = (customVariables: PianoCustomVariables) => {
  for (const key in customVariables) {
    window.tp?.push(['setCustomVariable', key, customVariables[key]])
  }
}

const setIsPlusTag = (isPlus?: boolean) => {
  if (isPlus) {
    window?.tp?.push?.(['setTags', ['isPlus']])
  } else {
    window?.tp?.push?.(['setTags', []])
  }
}

const setModalZIndexes = () => {
  window?.tp?.push?.([
    'setZIndexes',
    {
      backdrop: modalZIndex - 1,
      modal: modalZIndex,
      close: modalZIndex + 1,
    },
  ])
}

const doParseStringifiedData = (stringifiedData: string) => {
  let parsed = null
  try {
    parsed = JSON.parse(stringifiedData)
  } catch (e: any) {
    parsed = false
    captureException(e)
  }
  return parsed
}

const setExperienceCookie = (params: any): void => {
  document.cookie = `${experienceCookieName}=${encodeURIComponent(
    JSON.stringify(params)
  )}; expires=${(
    new Date(new Date().getTime() + 60 * 60 * 1000) as any
  ).toGMTString()}; path=/; domain=${window.location.hostname}`
}

const resetExperienceCookie = (): void => {
  document.cookie = `${experienceCookieName}=null; expires=-1; path=/; domain=${window.location.hostname}`
}

// make https request to our own service which generates a userRef token
const setUserRef = (cb: () => void): void => {
  fetch(tokenUrl, {
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data: PianoTokenResponse) => {
      window?.tp?.push?.(['setUserRef', data.userRefToken])
      cb()
    })
}

const globalPianoStyles = css`
  .tp-iframe-wrapper.tp-iframe-wrapper {
    box-shadow: none;
    margin-top: 0;
    margin-bottom: 0;
  }
  .pianocontainer:not(:empty) ~ *:not(.unblurred, aside) {
    filter: blur(7px);
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      z-index: 100;
    }
  }
`

export {
  doParseStringifiedData,
  resetExperienceCookie,
  setCustomVariables,
  setExperienceCookie,
  setIsPlusTag,
  setModalZIndexes,
  setUserRef,
  globalPianoStyles,
}
